import { render, staticRenderFns } from "./ServicesHeader.vue?vue&type=template&id=60f0dce3&scoped=true&"
import script from "./ServicesHeader.vue?vue&type=script&lang=js&"
export * from "./ServicesHeader.vue?vue&type=script&lang=js&"
import style0 from "./ServicesHeader.vue?vue&type=style&index=0&id=60f0dce3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f0dce3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
